import React from 'react'
import ProjectLayout from '../../../../../layout/components/ProjectLayout'
import ProjectNotes from '../components/ProjectNotes'
import { useParams } from 'react-router-dom'
import ActivityTimeline from '../components/activity/ActivityTimeline';
import ProjectTeam from '../components/ProjectTeam';
import ProjectTaskList from '../components/ProjectTaskList';

function ProjectDetailsPage() {
    const {id} = useParams();
    return (
        <ProjectLayout>
            <div className='row'>
                <div className='col-md-3 border'>
                    <ProjectTaskList projectId={id}  />
                </div>
                <div className='col-md-3 border'>
                    <ProjectTeam projectId={id} />
                </div>
                <div className='col-md-3 border'>
                    <ActivityTimeline projectId={id} />
                    
                </div>
                <div className='col-md-3'>
                    <ProjectNotes projectId={id}/>
                </div>
            </div>
        </ProjectLayout>
    )
}

export default ProjectDetailsPage